var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTechsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.2461 15.1253H86.1529",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0527 15.1253H70.3822",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0527 20.9974H86.1534",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_440_710",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 86,
    height: 86
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M92 92V8.6665H8.6665V92H92Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_440_710)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.2775 37.7777V42.8922C60.2775 45.0047 58.565 46.7172 56.4523 46.7172H53.2993",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.6361 86.3223H11.6043C10.1198 86.3223 8.9165 87.5256 8.9165 89.0101C8.9165 90.4945 10.1198 91.6978 11.6043 91.6978H70.6361C72.1206 91.6978 73.324 90.4945 73.324 89.0101C73.324 87.5256 72.1206 86.3223 70.6361 86.3223Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4738 86.3229C44.4738 84.1202 45.2991 82.0025 46.7728 80.3655C46.7838 80.3533 46.7948 80.341 46.8058 80.3287C48.011 78.9803 48.7438 77.201 48.7438 75.2502C48.7438 72.4073 47.1876 69.928 44.8806 68.6173C44.4429 68.3685 43.8994 68.6813 43.8994 69.1847V74.8565C43.8994 75.8072 43.1288 76.5778 42.1779 76.5778H40.0619C39.1113 76.5778 38.3404 75.8072 38.3404 74.8565V69.1847C38.3404 68.6813 37.7968 68.3685 37.3591 68.6173C35.0523 69.928 33.4961 72.4073 33.4961 75.2502C33.4961 77.201 34.2289 78.9803 35.4341 80.3287C35.4451 80.341 35.4561 80.3533 35.4671 80.3655C36.9408 82.0025 37.7661 84.1202 37.7661 86.3229",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3608 81.445L15.6255 86.3229",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.6152 86.3229L67.8541 63.4991C67.9732 61.3015 66.2236 59.4541 64.0226 59.4541H18.218C16.0171 59.4541 14.2673 61.3015 14.3866 63.4991L15.0456 75.6435",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.3237 86.9198V81.6836C72.3237 76.6402 70.5714 71.9447 67.5967 68.2356",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6435 68.2356C11.6688 71.9447 9.9165 76.6402 9.9165 81.6836V86.9198",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.8456 19.2211H53.7054C52.9296 19.2211 52.3006 18.5923 52.3006 17.8164C52.3006 15.5193 50.4386 13.6571 48.1414 13.6571H34.9032C29.0117 13.6571 24.2358 18.4329 24.2358 24.3244V31.374C24.2358 32.4095 24.891 33.3316 25.869 33.6721L28.4965 34.587C29.415 34.9068 30.3742 34.224 30.3727 33.2515L30.3669 28.2805C30.3569 25.8629 32.2847 23.8948 34.673 23.8844L34.725 23.8843C35.4562 23.8811 36.1792 23.9946 36.8699 24.2166C38.0935 24.6098 39.3615 24.8481 40.6469 24.8426H41.5937C42.879 24.8481 44.147 24.6098 45.3707 24.2166C46.0614 23.9946 46.7844 23.8811 47.5156 23.8843L47.5676 23.8844C49.9559 23.8948 51.8837 25.8629 51.8737 28.2805L51.8689 33.2518C51.8676 34.2243 52.8267 34.9068 53.7449 34.587L56.3717 33.6721C57.3496 33.3316 58.0047 32.4096 58.0047 31.3741V23.3804C58.0047 21.0833 56.1426 19.2211 53.8456 19.2211Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.478 40.9206H27.5014C27.5934 44.5463 29.1134 48.0301 31.8429 50.3888C34.0405 52.2878 37.1252 53.9403 41.1911 53.9689C45.2564 53.9056 48.3274 52.2268 50.5089 50.3091C53.1651 47.9744 54.6464 44.5686 54.7626 41.0194",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2359 30.8263C22.9431 31.0643 21.9629 32.195 21.9629 33.5566V38.3043C21.9629 39.839 23.2069 41.083 24.7416 41.083H27.4782V34.2323",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7627 34.2326V41.083H57.4992C59.0339 41.083 60.2779 39.839 60.2779 38.3045V33.5568C60.2779 32.1951 59.2977 31.0643 58.0049 30.8265",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5537 48.6793H47.4167C46.2198 48.6793 45.2495 47.7092 45.2495 46.5123C45.2495 45.3153 46.2198 44.3452 47.4167 44.3452H50.5537C51.7505 44.3452 52.7207 45.3153 52.7207 46.5123C52.7207 47.7092 51.7505 48.6793 50.5537 48.6793Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.985 59.4542C48.8365 58.8315 48.0781 57.6205 48.0781 56.2567V52.0665",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1626 52.0534V56.2565C34.1626 57.6437 33.3821 58.8396 32.252 59.4541",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.7498 15.0235V12.6042C91.7498 10.5965 90.1223 8.96901 88.1144 8.96901H67.0909C65.0831 8.96901 63.4556 10.5965 63.4556 12.6042V23.1189C63.4556 25.1265 65.0831 26.754 67.0909 26.754C68.2634 26.754 69.2139 27.7045 69.2139 28.877V35.3796C69.2139 36.2051 70.3011 36.5061 70.7256 35.7981L75.5308 27.7852C75.9143 27.1455 76.6056 26.754 77.3514 26.754H88.1144C90.1223 26.754 91.7498 25.1265 91.7498 23.1189V20.8675",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTechsupport);
export default __webpack_public_path__ + "static/media/icon_techsupport.e5c3cc8594efc3419dceaf6840e57332.svg";
export { ForwardRef as ReactComponent };